module.exports = __webpack_public_path__ + "static/img/floating-bg.60ac2f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hlSaled-2025/floating-bg.png
// module id = +ARU
// module chunks = 1